import {messagesService} from '@dv5/api'
import {remoteDocumentPartsService} from './remoteDocumentPartsService'

export const remoteDocumentPartsMessagesService = {
    register() {
        remoteDocumentPartsService.register()
        messagesService.registerService('remote-document-parts', {
            processors: {
                result: body => remoteDocumentPartsService.receive(body),
                changed: body => remoteDocumentPartsService.changed(body),
                error: body => remoteDocumentPartsService.fail(body),
            }
        })
    },
}
